// extracted by mini-css-extract-plugin
export default {"changeLink":"iO-z","disabled":"jO-z","inline":"kO-z"};